import 'bootstrap/dist/css/bootstrap.css';
global.jQuery = require('jquery');
require('bootstrap');

import '../sass/main.scss';

import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';

import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

import 'jquery-mask-plugin';
//import 'jquery-validation';

import 'calc-polyfill/calc.min';
import 'picturefill';

import 'aos/dist/aos.css';
import AOS from 'aos/dist/aos.js';

import gsap from './gsap.js';
import scrolltrigger from './scrolltrigger.js';


var setCookie = function (name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

var getCookie =  function(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

var eraseCookie =  function(name) {   
	document.cookie = name+'=; Max-Age=-99999999;';  
}

jQuery(document).ready(function($){

	if( getCookie('politicas') != 'true'){
		$('.cookies').removeClass('d-none');

		$(".prosseguir, .close").on('click tap touchstart', function(e) {
			e.preventDefault();
		   $('.cookies').addClass('d-none');
		   setCookie('politicas', 'true', 365);
	   });
	}

	$('.owl-home').owlCarousel({
		loop:true,
		nav:false,
		dots:true,
		items:1
	});

    $('#menu-hamburguer').change(function(){
        $('#header').toggleClass('active');
        $('.div-in-menu-hamburguer').toggleClass("fixedClick");
    });

    var scrollClass = function(){
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $('.div-in-menu-hamburguer').addClass("fixed");
        } else {
            $('.div-in-menu-hamburguer').removeClass("fixed");
        }
    }

    scrollClass();
    $(window).scroll(function() {
        scrollClass();
    });

});

